import { render, staticRenderFns } from "./Bookcover.vue?vue&type=template&id=51fe6661"
import script from "./Bookcover.vue?vue&type=script&lang=ts"
export * from "./Bookcover.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports